import { AlertInlineMain } from '@inmoment/the-kitchen';
import * as React from 'react';
import { CodeBlock } from '../../cookbook-ui/custom-components/CodeBlock/CodeBlock';
import { convertArrayToTabBar } from './utils/tabBarFn';

export interface Props {}

export const data1 = ['Chart Interfaces'].map(convertArrayToTabBar);

export const ChartWrapperDocumentation: React.FC<Props> = (props) => {
  return (
    <div>
      <AlertInlineMain color="error" title="Note!" subtitle="The ChartWrapper requires special configuration. See below for instructions" />
      <br></br>
      <h2>ChartWrapper Slots:</h2>
      The Chart wrapper relies on custom slots. These slots are outlined below
      <br />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <img style={{ height: 300 }} src="/_Images/chartWrapperSlots.png" alt="location of chart wrapper slots"></img>
      </div>
      <br />
      <div>
        <h3>Chart Slot:</h3>
        <CodeBlock
          code={`<div slot="chart" id="chart">
    <highcharts-chart [Highcharts]="highcharts" [options]="chartSettings" [style]="HighchartsAngularStyle" />
</div>`}
        />
        <br />
        In the chart slot (green outlined box) we directly placed the highcharts element. The options comes from the options creation process (see
        below) and the style comes from the Kitchen Export `HighchartsAngularStyle`. Do not apply any additional styling to this slot or
        highcharts-chart component.
        <br />
        <br />
        Also we have set the id on the slot to something unique. In this case `chart`
        <br />
        <br />
        <AlertInlineMain
          color="warning"
          title="Note!"
          subtitle="Setting the style to The Kitchen export of `HighchartsAngularStyle` and setting an id on the slot is VERY important. Failure to do so will result in bugs"
        />
        <br />
        <br />
        <h3>Filter Slot:</h3>
        <CodeBlock
          code={`<div slot="filter">
  <div> Anything you want here </div>
</div>
`}
        />
        <br />
        <br />
        The filter slot (blue box) goes to the right hand side of the title and subtitle. This slot is optional. You can put anything you want into
        it, however in order to keep appearances please limit the height of elements to the height of the title div to the left.
        <br />
        <br />
        <h3>Header Slot:</h3>
        <CodeBlock
          code={`<div slot="header">
  <div> Anything you want here </div>
</div>
        `}
        />
        <br />
        <br />
        The header slot (red box) goes directly above the chart. This slot is optional. The intended use of this slot is for elements such as search
        bars.
      </div>
      <br />
      <br />
      <h2>Width Resize Detection:</h2>
      <br />
      <br />
      The Chart wrapper requires a bit of configuration to properly do dynamic resizing of the chart width. If this is needed, the following
      ResizeObserver (or an equivalent) must be added.
      <br />
      <br />
      <CodeBlock
        code={`highcharts: typeof Highcharts = Highcharts;

ngOnInit(): void {
  const outputsize = () => {
    this.highcharts.charts[0]?.reflow(); //force the chart to reflow on observed change
    const element = document.getElementById('chart'); //The Id must match the chart slot Id
    if (element) {
      new ResizeObserver(outputsize).observe(element);
    }
  };
}`}
      />
      <br />
      <br />
      <h2>Styling:</h2>
      <br />
      <br />
      The Kitchen provides a default Highchart styling (HighchartsDefaultTheme) that should be applied to all charts, and then further adapted to meet
      your team's specific needs. To make use of the styling we have provided a function (HighchartsStyleMerge) that allows you to merge the default
      styling with one or more of your own style objects.
      <br />
      <br />
      When providing styling, do NOT provide a chart.height or a chart.width property. Doing so will prevent this component from functioning properly.
      <br />
      <br />
      <CodeBlock
        code={`import { HighchartsDefaultTheme, HighchartsAngularStyle, HighchartsStyleMerge } from '@inmoment/the-kitchen';
// ...

public chartSettings: any = HighchartsStyleMerge(HighchartsDefaultTheme, dxChart);

// ...`}
      />
      <br />
      <br />
      Note that the height properties below do not work here due to the below component being dynamically generated and unable to contain top level
      stylings.
    </div>
  );
};
